import React, {
    FC,
    useState,
} from "react";
import {TwoWheeler} from "@mui/icons-material";

interface IRenderGaragePhoto {
    value: string;
    size?: number;
    width?: number;
    height?: number;
}

export const RenderGaragePhoto: FC<IRenderGaragePhoto> = ({value, size = 50, width =50, height=50}) => {
    const [imgError, setImgError] = useState(false);
    const url = `https://fyd.ge/${value}`;

    return (
        <>
            {imgError || !value ? (
                <TwoWheeler
                    sx={{
                        fontSize: size,
                        color: "#ccc",
                        display: "block",
                    }}
                />
            ) : (
                <img
                    src={url}
                    alt="Garage"
                    onError={() => setImgError(true)}
                    style={{
                        width: `${width}px`,
                        height: `${height}px`,
                        objectFit: "cover",
                        borderRadius: 8,
                        display: "block",
                    }}
                />
            )}
        </>
    );
};
